import { ApolloError } from '@apollo/client'
import { showNotificationToast } from 'shared/utils/notify'
import { shortenAddress } from 'shared/utils/shorten-address'

/** Backend messages of linkWalletChallenge / linkWallet → what the user reads. */
const MESSAGES: Array<[RegExp, string]> = [
  [
    /already linked to your account/i,
    'This wallet is already linked to your account.'
  ],
  [
    /already used by another account/i,
    'This wallet belongs to another XYRO account and cannot be linked. A wallet that has already played without being linked belongs to its own account.'
  ],
  [/challenge expired or missing/i, 'The signing request expired. Try again.'],
  [/invalid signature/i, 'The signature did not match the wallet. Try again.'],
  [/invalid solana wallet address/i, 'This is not a valid Solana address.']
]

const getMessage = (error: unknown) =>
  error instanceof ApolloError ?
    (error.graphQLErrors[0]?.message ?? error.message)
  : error instanceof Error ? error.message
  : ''

export const getLinkWalletErrorMessage = (error: unknown): string => {
  const message = getMessage(error)

  return (
    MESSAGES.find(([pattern]) => pattern.test(message))?.[1] ??
    (message || 'Something went wrong. Try again.')
  )
}

export const notifyLinkWalletError = (error: unknown) => {
  console.error('Failed to link wallet', error)
  showNotificationToast({
    type: 'error',
    title: 'Could not link the wallet',
    description: getLinkWalletErrorMessage(error)
  })
}

export const notifySignatureDeclined = () =>
  showNotificationToast({ type: 'info', title: 'Signature declined' })

export const notifyAlreadyLinked = (address: string) =>
  showNotificationToast({
    type: 'info',
    title: 'Already linked',
    description: `${shortenAddress(address)} is one of your wallets and is now selected for play.`
  })

export const notifyWalletLinked = (address: string) =>
  showNotificationToast({
    type: 'success',
    title: 'Wallet linked',
    description: `${shortenAddress(address)} is linked and selected for play.`
  })
